import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { RrsTemplateLevel } from "server/models"
import {
    StoreType,
    addModal,
} from "client/store"
import {
    Link,
    TableColumn,
} from "client/components"

import TemplateLevelEdit from "../levelEdit"

const Columns = (editAccess: boolean) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const columns: TableColumn[] = [
        {
            field: "name",
            header: lang.name,
            cellMinWidth: "150px",
            formatter: (level: RrsTemplateLevel) => {
                if (editAccess) {
                    return (
                        <Link
                            href="/#"
                            onClick={() => dispatch(addModal({
                                key: "editLevel",
                                content: <TemplateLevelEdit levelId={level.id} />,
                            }))}
                        >
                            {level.name}
                        </Link>
                    )
                }
                return level.name
            },
        },
        {
            field: "shortName",
            header: lang.shortName,
            cellMinWidth: "150px",
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "150px",
        },
        {
            field: "order",
            header: lang.order,
            cellMinWidth: "100px",
        },
    ]

    if (editAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
